import { useRef } from 'react';
//@ts-expect-error module not typed
import UIModalIFrame from 'ui-addon-iframeable/host/UIModalIFrame';
import PortalIdParser from 'PortalIdParser';
import { getChannelInstanceId, getGenericChannelId, getSenderIdFromMessage } from 'conversations-message-history/common-message-format/operators/commonMessageGetters';
import { getFullUrl } from 'hubspot-url-utils';
import { getWAPhoneNumbersForMessage } from 'conversations-thread-data/whatsapp/public/operators';
import { jsx as _jsx } from "react/jsx-runtime";
export const MANUAL = 'MANUAL';
export const TWENTY_FOUR_HR_REPLY = 'TWENTY_FOUR_HR_REPLY';
const src = `${getFullUrl('app')}/messaging-embedded/${PortalIdParser.get()}/cv`;
const TemplateSendModal = ({
  handleClose,
  message,
  threadId,
  recipientId,
  templateInitiationType,
  messageLimitData
}) => {
  const noop = () => {};
  const channelInstanceId = getChannelInstanceId(message);
  const genericChannelId = getGenericChannelId(message);
  const senderId = getSenderIdFromMessage(message);
  const {
    senderPhoneNumber,
    recipientPhoneNumber
  } = getWAPhoneNumbersForMessage(message);
  const uiModalRef = useRef();
  return /*#__PURE__*/_jsx(UIModalIFrame, {
    embeddedPassthruProps: {
      genericChannelId,
      recipientId,
      recipientPhoneNumber,
      channelInstanceId,
      conversationThreadId: threadId,
      senderPhoneNumber,
      senderId,
      templateInitiationType,
      messageLimitData
    },
    appName: "Inbox",
    height: 700,
    name: "mmm-whatsapp-template-selector",
    use: "default",
    onClose: handleClose,
    onInitError: noop,
    onMessage: noop,
    onReady: noop,
    onReadyError: noop,
    src: src,
    scrolling: true,
    width: 1300,
    ref: uiModalRef
  });
};
TemplateSendModal.displayName = 'TemplateSendModal';
export default TemplateSendModal;